import { render } from "./InsuranceOnHoldOrders.vue?vue&type=template&id=28b61f8d"
import script from "./InsuranceOnHoldOrders.vue?vue&type=script&lang=js"
export * from "./InsuranceOnHoldOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/InsuranceOnHoldOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b61f8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b61f8d', __exports__)) {
    console.log('reload')
    api.reload('28b61f8d', __exports__)
  }
  
  module.hot.accept("./InsuranceOnHoldOrders.vue?vue&type=template&id=28b61f8d", () => {
    console.log('re-render')
    api.rerender('28b61f8d', render)
  })

}


export default __exports__